module.exports = __webpack_public_path__ + "static/media/pensioner-1.1ffd9992.png";